/**
 * @flow
 * @relayHash e55ca9c749a991daf0a685dfc828c54c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type JobCommentThread_job$ref = any;
type JobContractTab_job$ref = any;
type JobDeliverablesTab_job$ref = any;
type JobDeliverablesTab_stateTypes$ref = any;
type JobDetailsTab_job$ref = any;
type JobDetailsToggleFollowButton_job$ref = any;
type JobDetails_job$ref = any;
type JobDetails_stateTypes$ref = any;
type JobToolsTab_job$ref = any;
export type JobDetailsPageQueryVariables = {|
  id: string,
  first?: ?number,
  orderBy?: ?string,
|};
export type JobDetailsPageQueryResponse = {|
  +job: ?{|
    +$fragmentRefs: JobDetailsToggleFollowButton_job$ref & JobDetails_job$ref & JobDetailsTab_job$ref & JobCommentThread_job$ref & JobDeliverablesTab_job$ref & JobContractTab_job$ref & JobToolsTab_job$ref
  |},
  +jobState: ?{|
    +$fragmentRefs: JobDetails_stateTypes$ref
  |},
  +deliverableState: ?{|
    +$fragmentRefs: JobDeliverablesTab_stateTypes$ref
  |},
|};
export type JobDetailsPageQuery = {|
  variables: JobDetailsPageQueryVariables,
  response: JobDetailsPageQueryResponse,
|};
*/


/*
query JobDetailsPageQuery(
  $id: ID!
) {
  job(id: $id) {
    ...JobDetailsToggleFollowButton_job
    ...JobDetails_job
    ...JobDetailsTab_job
    ...JobCommentThread_job
    ...JobDeliverablesTab_job
    ...JobContractTab_job
    ...JobToolsTab_job
    id
  }
  jobState: __type(name: "JobStatus") {
    ...JobDetails_stateTypes
  }
  deliverableState: __type(name: "DeliverableState") {
    ...JobDeliverablesTab_stateTypes
  }
}

fragment JobDetailsToggleFollowButton_job on JobNode {
  id
  isCurrentUserFollowing
  followers {
    totalCount
  }
}

fragment JobDetails_job on JobNode {
  jobId
  name
  status
  jobDeadline
  id
  balance
  currencyCode
  releases {
    id
    name
    product {
      id
      title
    }
  }
}

fragment JobDetailsTab_job on JobNode {
  id
  contractSignDeadline
  contractor {
    id
    fullName
    representativeImageUrl
  }
  staffCoordinator {
    fullName
    representativeImageUrl
    id
  }
  contract {
    id
  }
  jobId
  name
  description
  created
  totalValue
  currencyCode
  contractDate
  totalValueInHomeCurrency
  status
  deliverableCategory {
    name
    id
  }
}

fragment JobCommentThread_job on JobNode {
  id
  staffCoordinator {
    id
  }
  deliverableCoordinators {
    id
  }
  comments {
    edges {
      node {
        id
        content
        created
        contentEditedAt
        extraData
        commentType
        repliedTo {
          content
          created
          user {
            fullName
            id
          }
        }
        user {
          id
          fullName
          representativeImageUrl
        }
      }
    }
  }
}

fragment JobDeliverablesTab_job on JobNode {
  id
  deliverables(orderBy: "title") {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edgeCount
    edges {
      cursor
      node {
        id
        title
        state
        dueDate
        amount
        currencyCode
        reviewStep
        categoryType {
          name
          id
        }
        assignedStaff {
          representativeImageUrl
          fullName
          user {
            id
          }
          id
        }
        release {
          product {
            id
            title
          }
          id
        }
      }
    }
  }
}

fragment JobContractTab_job on JobNode {
  contract {
    id
    contractId
    dateSignedByOrganization
    dateSignedByContractor
    signedPdfByContractorUrl
    signedPdfByOrganizationUrl
    finalizedPdfUrl
    template {
      name
      id
    }
  }
  id
  jobId
  status
  associatedFiles(first: 50) {
    edges {
      node {
        id
        fileName
        fileSize
        fileUrl
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment JobToolsTab_job on JobNode {
  id
  status
  hasCompletedDeliverables
  history {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        id
        timestamp
        actor {
          orgStaff {
            fullName
            representativeImageUrl
            id
          }
          freelancer {
            fullName
            representativeImageUrl
            id
          }
          id
        }
        action
        changes
        additionalData
      }
    }
  }
}

fragment JobDetails_stateTypes on __Type {
  enumValues {
    name
    description
  }
}

fragment JobDeliverablesTab_stateTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "JobStatus"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "DeliverableState"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currencyCode",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "product",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductNode",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v8/*: any*/)
  ]
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v12 = [
  (v4/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v4/*: any*/)
],
v14 = [
  (v6/*: any*/),
  (v4/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v17 = [
  (v4/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasNextPage",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endCursor",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "edgeCount",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v24 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "enumValues",
    "storageKey": null,
    "args": null,
    "concreteType": "__EnumValue",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      (v15/*: any*/)
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "JobDetailsPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "job",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "JobNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobDetailsToggleFollowButton_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobDetails_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobDetailsTab_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobCommentThread_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobDeliverablesTab_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobContractTab_job",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "JobToolsTab_job",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobState",
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobDetails_stateTypes",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "deliverableState",
        "name": "__type",
        "storageKey": "__type(name:\"DeliverableState\")",
        "args": (v3/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobDeliverablesTab_stateTypes",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "JobDetailsPageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "job",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "JobNode",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isCurrentUserFollowing",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "followers",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNodeConnection",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "jobId",
            "args": null,
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "jobDeadline",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "balance",
            "args": null,
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "releases",
            "storageKey": null,
            "args": null,
            "concreteType": "ReleaseNode",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v9/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contractSignDeadline",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contractor",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "staffCoordinator",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": (v13/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractNode",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "contractId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dateSignedByOrganization",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dateSignedByContractor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signedPdfByContractorUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "signedPdfByOrganizationUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "finalizedPdfUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "template",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractTemplateNode",
                "plural": false,
                "selections": (v14/*: any*/)
              }
            ]
          },
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalValue",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contractDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalValueInHomeCurrency",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "deliverableCategory",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryNode",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "deliverableCoordinators",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": true,
            "selections": (v17/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "comments",
            "storageKey": null,
            "args": null,
            "concreteType": "CommentNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CommentNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommentNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v18/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "contentEditedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "extraData",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "commentType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "repliedTo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommentRepliedToNode",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v16/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": (v12/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "deliverables",
            "storageKey": "deliverables(orderBy:\"title\")",
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "title"
              }
            ],
            "concreteType": "DeliverableNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreviousPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startCursor",
                    "args": null,
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ]
              },
              (v5/*: any*/),
              (v21/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DeliverableNodeEdge",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DeliverableNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dueDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "amount",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reviewStep",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "categoryType",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryTypeNode",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "assignedStaff",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "release",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReleaseNode",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "associatedFiles",
            "storageKey": "associatedFiles(first:50)",
            "args": (v23/*: any*/),
            "concreteType": "JobAssociatedFileNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "JobAssociatedFileNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobAssociatedFileNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileSize",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "fileUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v22/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "associatedFiles",
            "args": (v23/*: any*/),
            "handle": "connection",
            "key": "JobContractTab_associatedFiles",
            "filters": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasCompletedDeliverables",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "history",
            "storageKey": null,
            "args": null,
            "concreteType": "LogEntryNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v5/*: any*/),
              (v21/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "LogEntryNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LogEntryNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "timestamp",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "actor",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "orgStaff",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StaffNode",
                            "plural": false,
                            "selections": (v13/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "freelancer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FreelancerNode",
                            "plural": false,
                            "selections": (v13/*: any*/)
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "action",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "changes",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "additionalData",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobState",
        "name": "__type",
        "storageKey": "__type(name:\"JobStatus\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": "deliverableState",
        "name": "__type",
        "storageKey": "__type(name:\"DeliverableState\")",
        "args": (v3/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": (v24/*: any*/)
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "JobDetailsPageQuery",
    "id": null,
    "text": "query JobDetailsPageQuery(\n  $id: ID!\n) {\n  job(id: $id) {\n    ...JobDetailsToggleFollowButton_job\n    ...JobDetails_job\n    ...JobDetailsTab_job\n    ...JobCommentThread_job\n    ...JobDeliverablesTab_job\n    ...JobContractTab_job\n    ...JobToolsTab_job\n    id\n  }\n  jobState: __type(name: \"JobStatus\") {\n    ...JobDetails_stateTypes\n  }\n  deliverableState: __type(name: \"DeliverableState\") {\n    ...JobDeliverablesTab_stateTypes\n  }\n}\n\nfragment JobDetailsToggleFollowButton_job on JobNode {\n  id\n  isCurrentUserFollowing\n  followers {\n    totalCount\n  }\n}\n\nfragment JobDetails_job on JobNode {\n  jobId\n  name\n  status\n  jobDeadline\n  id\n  balance\n  currencyCode\n  releases {\n    id\n    name\n    product {\n      id\n      title\n    }\n  }\n}\n\nfragment JobDetailsTab_job on JobNode {\n  id\n  contractSignDeadline\n  contractor {\n    id\n    fullName\n    representativeImageUrl\n  }\n  staffCoordinator {\n    fullName\n    representativeImageUrl\n    id\n  }\n  contract {\n    id\n  }\n  jobId\n  name\n  description\n  created\n  totalValue\n  currencyCode\n  contractDate\n  totalValueInHomeCurrency\n  status\n  deliverableCategory {\n    name\n    id\n  }\n}\n\nfragment JobCommentThread_job on JobNode {\n  id\n  staffCoordinator {\n    id\n  }\n  deliverableCoordinators {\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n        content\n        created\n        contentEditedAt\n        extraData\n        commentType\n        repliedTo {\n          content\n          created\n          user {\n            fullName\n            id\n          }\n        }\n        user {\n          id\n          fullName\n          representativeImageUrl\n        }\n      }\n    }\n  }\n}\n\nfragment JobDeliverablesTab_job on JobNode {\n  id\n  deliverables(orderBy: \"title\") {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edgeCount\n    edges {\n      cursor\n      node {\n        id\n        title\n        state\n        dueDate\n        amount\n        currencyCode\n        reviewStep\n        categoryType {\n          name\n          id\n        }\n        assignedStaff {\n          representativeImageUrl\n          fullName\n          user {\n            id\n          }\n          id\n        }\n        release {\n          product {\n            id\n            title\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment JobContractTab_job on JobNode {\n  contract {\n    id\n    contractId\n    dateSignedByOrganization\n    dateSignedByContractor\n    signedPdfByContractorUrl\n    signedPdfByOrganizationUrl\n    finalizedPdfUrl\n    template {\n      name\n      id\n    }\n  }\n  id\n  jobId\n  status\n  associatedFiles(first: 50) {\n    edges {\n      node {\n        id\n        fileName\n        fileSize\n        fileUrl\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JobToolsTab_job on JobNode {\n  id\n  status\n  hasCompletedDeliverables\n  history {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        timestamp\n        actor {\n          orgStaff {\n            fullName\n            representativeImageUrl\n            id\n          }\n          freelancer {\n            fullName\n            representativeImageUrl\n            id\n          }\n          id\n        }\n        action\n        changes\n        additionalData\n      }\n    }\n  }\n}\n\nfragment JobDetails_stateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n\nfragment JobDeliverablesTab_stateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0c48f51744226d7995cb4eb132a678f';
module.exports = node;
